import { tempScale } from "constants/temp-scale";
import styled from "styled-components";
import { colorPrimary, colorMain } from "./colors";
import { headerFont } from "./generic";

interface TrackProps {
  color?: string;
}

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 35px 0 40px 0;
  padding: 0 10px;

  @media (max-width: 600px) {
    margin: 35px 0 15px 0;
  }
`;

export const Track = styled.div<TrackProps>`
  height: 5px;
  width: 100%;
  background-color: ${(p) => (p?.color ? p.color : null)};
  border-radius: 4px;
`;

interface ThumbProps {
  bgColor?: string;
}

export const Thumb = styled.div<ThumbProps>`
  height: 15px;
  width: 15px;
  border-radius: 21px;
  background-color: ${(p) => (p?.bgColor ? p.bgColor : colorPrimary)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ThumbLabel = styled.div`
position: absolute;
top: -60px;
color: ${colorPrimary};
font-weight: bold;
font-size: 14px;
font-family: Arial;Helvetica Neue;Helvetica;sans-serif;
`;

interface MarkParagraphProps {
  selectedValue: number;
  value: number;
}

export const MarkParagraph = styled.p<MarkParagraphProps>`
  position: relative;
  display: ${(p) => (tempScale.marks.includes(p.value) ? "block" : "none")};
  margin-top: 25px;
  font-weight: 600;
  font-size: 14px;
  color: ${(p) => (p.selectedValue < p.value ? colorMain : colorPrimary)};
`;

export const Mark = styled.div`
  height: 0;
  width: 0;
  background-color: ${colorMain};
  min-width: 37px;
`;

export const TemperatureHeader = styled.h3`
  margin: 0;
  margin-bottom: 50px;
  font-size: ${headerFont};

  @media (max-width: 600px) {
    font-size: 1.3rem;
  }

  @media (max-width: 900px) {
    margin-top: -30px;
  }
`;

export const TeardropValue = styled.span`
  transform: rotate(-45deg);
`;

export const TeardropWrapper = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50% 50% 0 50%;
  border: 3px solid var(--primary-color);
  transform: rotate(45deg);
  margin-top: 10px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  align-items: center;
`;
